// Code review - Completed
// Documentation - Completed
import React from "react";
import TopMenu from "./TopMenu";
import SideMenu from "./SideMenu";
import MobileMenu from "./mobileMenu";

const MainLayout = ({ children, pageName }) => {
  return (
    <div className="w-full h-screen flex flex-col">
      {/* Fixed Top Menu */}
      <div className="w-full flex-none">
        <TopMenu />
      </div>

      {/* Main Content Area with Fixed Side Menu */}
      <div className="flex-1 flex overflow-hidden">
        {/* Side Menu - Desktop */}
        <div className="hidden lg:block flex-none h-full">
          <SideMenu pageName={pageName} />
        </div>

        {/* Mobile Menu */}
        <div className="lg:hidden">
          <MobileMenu pageName={pageName} />
        </div>

        {/* Scrollable Content Area */}
        <div className="flex-1 overflow-auto px-4">
          <div className="min-w-0">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
